const isProduction = () => window.location.href.includes("https://talent.performyard.com");

export default isProduction;
